import { render, staticRenderFns } from "./DyorLogo.vue?vue&type=template&id=926aeaaa&scoped=true"
import script from "./DyorLogo.vue?vue&type=script&lang=js"
export * from "./DyorLogo.vue?vue&type=script&lang=js"
import style0 from "./DyorLogo.vue?vue&type=style&index=0&id=926aeaaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926aeaaa",
  null
  
)

export default component.exports